import { IPreloadedState } from 'shared/types/redux';

export const selectRegionalDistrictsModal = (state: IPreloadedState) => state.geo.regionalDistrictsModal;
